import React from "react";
import { Navigate } from "react-router-dom";

const SignupPathway = () => <Navigate to="/signup" replace />;

export default SignupPathway;
